import { signalStore, withState, withMethods, patchState, withComputed } from '@ngrx/signals';
import { computed } from '@angular/core';
import { Access } from 'src/Utilities/enum';

export interface UserModel {
  UserId: number;
  IqviaId: string;
  RoleId: number;
}

export interface PermissionModel {
  ScreenId: number;
  FunctionId: number;
  Permission: Access;
}

interface AuthState {
  userAccessData: UserModel[];
  permissionData: PermissionModel[];
  RoleId: number | null;
  isAdminUser: boolean;
}

const initialState: AuthState = {
  userAccessData: [],
  permissionData: [],
  RoleId: null,
  isAdminUser: false
};

export const AuthStore = signalStore(
  { providedIn: 'root' },
  withState(initialState),
  withComputed((store) => ({
    currentRoleId: computed(() => {
      const users = store.userAccessData();
      return users.length > 0 ? users[0].RoleId : null;
    }),
    hasPermissions: computed(() => store.permissionData().length > 0),
    isAdmin: computed(() => store.isAdminUser())
  })),
  withMethods((store) => ({
    setUserAccessData(data: UserModel[]) {
      const roleId = data.length > 0 ? data[0].RoleId : null;
      patchState(store, { userAccessData: data, RoleId: roleId });
    },
    setPermissionData(data: PermissionModel[]) {
      patchState(store, { permissionData: data });
    },
    setIsAdminUser(isAdmin: boolean) {
      patchState(store, { isAdminUser: isAdmin });
    },
    getPermission(screenId: number, functionId: number): Access {
      const permissions = store.permissionData();
      if (!permissions || permissions.length === 0) {
        return Access.NoAccess;
      }
      const matchedPermission = permissions.find(
        (p) => p.ScreenId === screenId && p.FunctionId === functionId
      );
      return matchedPermission ? matchedPermission.Permission : Access.NoAccess;
    },
    isVisible(functionId: number): boolean {
      const permissions = store.permissionData();      
      if (!permissions || permissions.length === 0) {
        return false;
      }
      const matchedPermission = permissions.find(
        (p) =>  p.FunctionId === functionId
      );
      let Isvisible = matchedPermission.Permission === Access.ReadWrite ? true : false;
      return Isvisible;
    },
    reset() {
      patchState(store, initialState);
    }
  }))
);
